import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import '@fontsource/libre-baskerville/400.css'
import '@fontsource/libre-baskerville/700.css'
import '@fontsource/noto-serif-sc/400.css'
import '@fontsource/noto-serif-sc/600.css'
import '@fontsource/noto-serif-sc/700.css'
import '@fontsource/noto-sans-sc/400.css'
import '@fontsource/noto-sans-sc/500.css'
import '@fontsource/noto-sans-sc/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import '@fontsource/jetbrains-mono/700.css'

import '@kit/styles/tokens.css'
import '@kit/styles/app.css'
import { I18nProvider } from './locales/i18n'

const AppA = lazy(() => import('./apps/a/App').then((module) => ({ default: module.App })))
const AppB = lazy(() => import('./apps/b/App').then((module) => ({ default: module.App })))
const AppC = lazy(() => import('./apps/c/App').then((module) => ({ default: module.App })))
const AppOps = lazy(() => import('./apps/ops/App').then((module) => ({ default: module.App })))
const AppAdmission = lazy(() => import('./apps/admission/App').then((module) => ({ default: module.App })))
const SharedReportApp = lazy(() => import('./apps/a/SharedReportApp'))

const container = document.getElementById('root')
if (!container) throw new Error('#root not found')

// 宿主装配点:窗口按显式 app 参数装配;默认保持 W-A,不改变既有入口。
const appKey = new URLSearchParams(window.location.search).get('app')
const reportShare = new URLSearchParams(window.location.search).get('report_share')
const App = reportShare ? SharedReportApp : appKey === 'b' ? AppB : appKey === 'c' ? AppC : appKey === 'ops' ? AppOps : appKey === 'admission' ? AppAdmission : AppA

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <Suspense fallback={<div className="nv-app-loading" role="status" aria-live="polite">Navigator</div>}>
        <App />
      </Suspense>
    </I18nProvider>
  </StrictMode>,
)
